import { css } from '@emotion/react';

export const resetInput = css`
  background: none;
  outline: none;
  border: none;
`;
